import { setTheme } from "theme/default/setTheme";

export const setFontWeight700 = setTheme(({ theme }) => `font-weight: ${theme.fontWeightValues.font_weight_700}`);
